import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  tariffGetImage,
  tariffAddImage
} from "actions/chargers/tariff/actions";
import Spinner from "../../../lib/components/Spinner";

class ImageModal extends React.Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      file: false
    };
  }

  handleChange = (ev) => {
    const files = Array.from(ev.target.files);
    this.setState({
      file: files[0]
    });
  };

  handleSubmit = () => {
    this.props.tariffAddImage(this.props.tariffId, this.state.file, () => {
    });
  };

  render() {
    const {
      loading,
      tariffName,
      tariffImage
    } = this.props;
    const { file } = this.state;

    return (
      <div className="position-relative">
        {!loading || <Spinner/>}
        <div className="my-2 text-center">
          {tariffImage
            ? (
              <img
                className="img-thumbnail"
                alt={tariffName}
                src={tariffImage}
                style={{
                  maxHeight: 200,
                  width: "auto"
                }}
              />
            ) : null}
        </div>

        <div className="form-group">
          <label>Logo</label>
          <input
            className="form-control"
            type="file"
            accept="image/png"
            onChange={this.handleChange}
          />
        </div>

        <div className="text-right">
          <button
            className="btn btn-danger mr-2"
            onClick={this.props.onCancel}
          >
            Cancel
          </button>
          <button
            className="btn btn-success"
            onClick={this.handleSubmit}
            disabled={file === false}
          >
            Upload
          </button>
        </div>
      </div>
    );
  }
}

ImageModal.propTypes = {
  tariffId: PropTypes.string.isRequired,
  tariffName: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  loading: state.chargerTariff.loading,
  tariffImage: state.chargerTariff.tariffImage,
});

const mapStateToDispatch = dispatch => ({
  tariffGetImage: bindActionCreators(tariffGetImage, dispatch),
  tariffAddImage: bindActionCreators(tariffAddImage, dispatch),
});

export default connect(
  mapStateToProps,
  mapStateToDispatch
)(ImageModal);



// WEBPACK FOOTER //
// ./src/views/pages/chargers/tariff/image-modal.js